// Auto-generated file created by svgr-cli source svg-template.js
// Run yarn icons:create to update
// Do not edit
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgOnMusic = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="none"
    viewBox="0 0 32 32"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#F8F8F8"
      d="M27.87 14.85q0-3.285-1.721-5.995a10.73 10.73 0 0 0-4.617-4.058 1.75 1.75 0 0 1-.86-.85 1.52 1.52 0 0 1-.08-1.168q.235-.634.843-.91a1.44 1.44 0 0 1 1.232 0q3.795 1.702 6.064 5.205T31 14.85t-2.27 7.779-6.065 5.203a1.44 1.44 0 0 1-1.233 0 1.55 1.55 0 0 1-.84-.91 1.51 1.51 0 0 1 .078-1.167q.275-.573.86-.852 2.896-1.345 4.618-4.056 1.72-2.71 1.721-5.997M9.09 19.64H4.395q-.665 0-1.114-.456t-.45-1.127v-6.333q0-.673.45-1.127.45-.455 1.114-.456H9.09l5.165-5.225q.743-.752 1.702-.337.96.415.958 1.485v17.653q0 1.068-.958 1.485-.957.416-1.702-.338zm14.868-4.75a6.94 6.94 0 0 1-.744 3.148q-.742 1.484-1.956 2.433a.77.77 0 0 1-.803.02q-.411-.216-.41-.693V9.903q0-.474.412-.692a.77.77 0 0 1 .801.02q1.213.99 1.956 2.493a7.06 7.06 0 0 1 .744 3.166"
    />
  </svg>
);
export default SvgOnMusic;
